import i18next from 'i18next';

i18next.addResources('es', 'Player', {
  altBtnPlay: 'Reproducir'
});

i18next.addResources('en-US', 'Player', {
  altBtnPlay: 'Play'
});
